import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/bidder-web/src/components/PostHogInit.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Syne\",\"arguments\":[{\"weight\":[\"600\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-syne\"}],\"variableName\":\"syne\"}");
;
import(/* webpackMode: "eager" */ "/app/apps/bidder-web/src/app/generated-tokens.css");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/styles/spinner.css");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/styles/skeleton.css");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/styles/reduced-motion.css");
;
import(/* webpackMode: "eager" */ "/app/apps/bidder-web/src/app/globals.css");
